export const IS_FUTURE_DATE_MESSAGE = "Date mustn't be in the past";
export const IS_FUTURE_TIME_MESSAGE = 'Time must be in the future';
